import React from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Folder as FolderIcon,
  Info as InfoIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Science as ScienceIcon,
  Assignment as AssignmentIcon,
  Mic as MicIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { usePageTranslation } from '../i18n/hooks';

export const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { t: navT } = usePageTranslation('nav');
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const menuItems = [
    { text: navT('home') || 'Home', path: '/', icon: <HomeIcon /> },
    { text: navT('projects') || 'Interviews', path: '/projects', icon: <MicIcon /> },
    { text: navT('surveys') || 'Surveys', path: '/surveys', icon: <AssignmentIcon /> },
    { text: navT('guide') || 'Interview Guide', path: '/guide', icon: <QuestionAnswerIcon /> },
    { text: navT('research') || 'Research', path: '/research', icon: <ScienceIcon /> },
    { text: navT('about') || 'About Us', path: '/about', icon: <InfoIcon /> }
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <List>
        {menuItems.map((item) => (
          <ListItem 
            button 
            key={item.text}
            onClick={() => {
              navigate(item.path);
              setMobileOpen(false);
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Qualitati
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiDrawer-paper': { width: 240 },
        }}
      >
        {drawer}
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${240}px)` },
          mt: 8
        }}
      >
        {children}
      </Box>
    </Box>
  );
}; 